export default __webpack_public_path__ + "static/media/show-feeder-2.0b2eebd4.webp";